const url = '/payment-terms-options';
const Provider = 'PaymentTermsOptions';
const dbModel = 'PaymentTermsOptions';

export { url, Provider, dbModel };
